import { defineStore } from 'pinia';
import { apiClient } from '@/shared/services/api';

export const useFeatureFlagsStore = defineStore('featureFlags', {
  state: () => ({
    loaded: false,
    loading: false,
    fennecMode: true,
    worldCup: true,
    soccerV2: true,
    liveStream: true,
    gamification: true,
    reels: true,
    careers: true,
    chat: true,
    marketplace: true,
    forums: true,
    events: true,
    stories: true,
    videoCall: false,
  }),

  actions: {
    async fetchFlags() {
      if (this.loading) return;
      this.loading = true;
      try {
        const response = await apiClient.get('/app-config/features');
        const flags = response?.data?.features ?? response?.data?.data?.features;
        if (flags && typeof flags === 'object') {
          for (const [key, val] of Object.entries(flags)) {
            if (key in this.$state && key !== 'loaded' && key !== 'loading') {
              this[key] = val !== false;
            }
          }
        }
      } catch {
        /* network failure → keep defaults (all true) */
      } finally {
        this.loaded = true;
        this.loading = false;
      }
    },
  },
});
